export enum FormSettingsPermissions {
  FormSetting = 'form-setting',
}
